<template>
    <div class="setting-content--section">
        <b-form @submit="onSubmit">
            By clicking the "Delete" button at the end of this page, you are making a request to delete all your
            information stored on this website.
            <br>
            The following will be permanently deleted from the Gekko databases:
            <ul>
                <li>
                    Your profile.
                </li>
                <li>
                    The companies for which you are an owner.
                </li>
                <li>
                    All media related to this account.
                </li>
                <li>
                    All your invoices, costs, expenses, etc.
                </li>
            </ul>
            This is the deletion procedure:
            <ol>
                <li>
                    Click Delete on the bottom of this page.
                </li>
                <li>
                    Receive a confirmation E-mail and click on the link to initiate the deletion procedure.
                </li>
                <li>
                    In 4 days, a final e-mail will be sent in case you still wish to download your data.
                </li>
                <li>
                    After 5 days, your account and all data on it will be deleted.
                </li>
            </ol>
            Please remember to save all your important data from your account before it is deleted, as there is no way
            to
            recover the information once the deletion procedure has completed.
            <br>
            If you change your mind and choose to stop the deletion procedure, you will be able to do this by clicking
            on
            the red bar that will appear on top of the page once the deletion procedure starts.
            <b-row>
                <b-col cols="4">
                    <div class="form-group">
                        <label>Password*</label>
                        <b-form-input type="password" id="text-password" v-model="form.password"
                            placeholder="Password..." required>
                        </b-form-input>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="4">
                    <div class="form-group">
                        <label>Reason*</label>
                        <b-form-textarea id="text-reason" v-model="form.reason" placeholder="Enter your reason here..."
                            required></b-form-textarea>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="4">
                    <div class="form-group">
                        <b-button type="submit" variant="primary">Delete</b-button>
                    </div>
                </b-col>
            </b-row>
        </b-form>
    </div>
</template>

<script>
import UserService from "@/store/services/user.service.js";
import settingsPageSetup from "@/mixins/settingsPageSetup";

export default {
    name: "AccountDelete",
    components: {},
    mixins: [settingsPageSetup],
    data() {
        return {
            pageSettings: {
                title: this.$gettext("Delete profile"),
                showCompanyPicker: false
            },
            form: {
                password: null,
                reason: null,
            },
        }
    },
    methods: {
        onSubmit(event) {
            event.preventDefault();
            var encryptedPassword = window.btoa(this.form.password);
            UserService.deleteAccount({ password: encryptedPassword, reason: this.form.reason }).then((response) => {
                if (response.status == 200) {
                    this.$store.commit('setAlert', {
                        title: this.$gettext("Success"),
                        text: this.$gettext("Successfully started the deletion procedure. Please check your e-mail for confirmation!"),
                        duration: 4
                    });
                }
            }).catch((response) => {
                switch (response.status) {
                    case 400:
                        this.$store.commit('setAlert', {
                            title: this.$gettext("Too soon"),
                            text: this.$gettext("You have changed your email address less than two weeks ago. Please try again later."),
                            variant: "error",
                            duration: 4
                        });
                        break;
                    case 403:
                        this.$store.commit('setAlert', {
                            title: this.$gettext("Wrong password"),
                            text: this.$gettext("Your password is incorrect. Please enter the correct password."),
                            variant: "error",
                            duration: 4
                        });
                        break;
                    case 500:
                        this.$store.commit('setAlert', {
                            title: this.$gettext("Something went wrong"),
                            text: this.$gettext("Something went wrong when trying to delete your account. Please try again later."),
                            variant: "error",
                            duration: 4
                        });
                        break;
                }
            });
            event.preventDefault();
        }
    }
};
</script>

<style >

</style>
